export const TASKS_STATUSES = {
  TODO: 1,
  INPROGRESS: 2,
  DONE: 3,
  ARCHIVED: 4,
} as const;

export const TASKS_NAMES = {
  1: "Do zrobienia",
  2: "W trakcie",
  3: "Zakończone",
  4: "Zarchiwizowane",
} as const;
export const TASKS_OPTIONS = [
  { value: TASKS_STATUSES.TODO, label: "Do zrobienia" },
  { value: TASKS_STATUSES.INPROGRESS, label: "W trakcie" },
  { value: TASKS_STATUSES.DONE, label: "Zakończone" },
];
export const ISSUE_ACTIVITY_TYPES = {
  MoveStatus: 1,
  Comment: 2,
  Assignement: 3,
  Modification: 4,
} as const;
